import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';
import { Menu, Dropdown, Button, Row, Col, Avatar, Tooltip,Popover, message, Modal, Checkbox } from 'antd';
import {
  isPdfOnlineDomain,
  // prop,
  windowActionFn,
  getPrivacyPolicyUrl,
  getTermsOfServiceUrl,
  isJPDomain,
  isCNDomain, getFileNameAndType,
} from 'Utils/utils';
import { baseUrlApis, clientApi } from 'Api/index';
import { FOXIT_STORAGE } from 'Api/drives.constants';
import { isTeamsAndroid, isWindows } from '../../utils/device';
import { storageGetItem, storageSetItem, isCanvas } from '@/utils/utils';

import {
  ABOUT_FOXIT_SOFTWARE,
  SUBSCRIBE,
  PRIVACY_POLICY,
  TERM_OF_SERVICE
} from 'Components/viewer/ui/constants/user.more.constants';
import {
  OPEN_FILE,
} from 'Components/viewer/ui/constants/other.constants';
import {
  CREATE_BLANK_PDF,
} from 'Components/viewer/ui/constants/convert.constants';
import { HOME_PRINT } from 'Components/viewer/ui/constants/home.constants';
import {
  SAVE_TO_LOCAL,
} from 'Components/viewer/ui/constants/savefile.constants';
import {store} from 'Store/store.index';
import switchLangIcon from '@/assets/user/switch-lang.svg';
import langChange from '@/assets/user/langchange.svg';
import helpIcon from '@/assets/user/help-icon.svg';
import langTipsIcon from '@/assets/user/lang-tips-icon.svg';
import topClose from '@/assets/user/topClose.svg';
import SavingIcon from '@/assets/HeaderContainer/saving.svg';
import SavedIcon from '@/assets/HeaderContainer/saved.svg';
import { HOME_HEADER, COMMON_HEADER, COLLABORATION_HEADER /* COLLABORATION_HEADER */ } from '@/constants/index';
import './header.scss';
import './HeaderContainer.scss'
import CollaborationHeader from './CollaborationHeader'
import DocumentNameHeader from './DocumentNameHeader';
import NotificationPopover from './NotificationPopover'
import {
  PRINT,
} from '../viewer/ui/constants/event.constants.share';
import { UPDATE_LOG_STATE_CHANGED } from 'Constants/app.constant';
import InstallPWAs from 'Components/dialogs/InstallPWAs/InstallPWAs'
import { HeaderEntrance } from 'Components/dialogs/index';
import { isSharedClound } from '@/api/index'
import { LANG_CHANGE } from 'Store/constants';
import { EduGuidePopup, isDismissEduGuidePopup } from './components/EduGuidePopup';
import { collaborationApi } from '@/api/index';
import { collaborationService, iManageService } from '@/store/services/index';
import { MULTI_TABS_TYPES } from 'Components/MultiTabsBar/contant'
import HeaderAvatar from './components/Avator/HeaderAvatar';

import UndoButton from './components/UndoButton';
import RedoButton from './components/RedoButton';

import {
  EDIT_WITH_EDITOR_CLOUD,
  SAVE_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING,
  DOWNLOAD_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING
} from 'Components/viewer/ui/constants/view.constants';
import LMSSubBtn from 'Components/header/lmsSubBtn';
import DocOrigin from './DocOrigin';
import SavingTip from '../Storage/SavingTip';
import ShareDocButton from './components/ShareDocButton/ShareDocButton';
import { fileController } from '../viewer/Controllers';
import Shortcut from '../../../foxitwebsdk/src/shared/Shortcut.js';
import CustomizeQuickAccessToolbar from 'Components/header/CustomizeQuickAccessToolbar';

let savingSharePointFile = false;
@inject('appStore', 'userStore', 'accountStore', 'historyStore', 'loginNewStore')
@observer
class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.onLogoClick = this.onLogoClick.bind(this);
    this.onChangeLang = this.onChangeLang.bind(this);
    this.onChangeHelp = this.onChangeHelp.bind(this);
    this.onClickContactUs = this.onClickContactUs.bind(this);
    this.onSubscribe = this.onSubscribe.bind(this);
    this.state={
      isProtectedView: localStorage.getItem('SECURITY_PROTECTED_VIEW')==='all' ? true: false,
      isShowLangTips:false,
      isShowLangDropdown: false,
      isShowHelpDropdown: false,
      targetLng:'',
      privacyPolicyUrl: '',
      termsOfServiceUrl: '',
      isShowDownloadEditorCloudAppModal: false,
      isShowDownloadAppModal: false,
      downloadAppModalContent: '',
      downloadAppModalTitle: '',
      isShowStartEditorCloudAppModal: false,
      startEditorCloudAppModalContent: '',
      isShowStartEditorCloudAppModalCheckboxValue: false,
      saveLocalFileConfig: {
        auto_open: false, open_phantom: false
      },
      showWhatsNewDot: true,
      langNewKey: Math.random(),
    };
    this.saveFileDebounce = false;
  }
  componentDidMount () {
    store.appStore.getAppLogoAsync();
    store.appStore.addAppEventListener(LANG_CHANGE,this.langChange)

    if(!isJPDomain() && !isCNDomain()){
      this.isChangeLang();
    }
    this.checkWhatSNewState();
    store.appStore.addAppEventListener(UPDATE_LOG_STATE_CHANGED,this.changeWhatSNewState);

    Shortcut.register(document.body, 'ctrl+s', (e) => {
      // Save
      e.preventDefault();
      const { headerType } = store.appStore;
      const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
      if (headerType !== COMMON_HEADER || !pdfDocRender) return ;
      if (store.docStore.docDriveName === 'Storage') {
        this.onSaveFileTo();
      } else if (isCNDomain()) {
        this.onSaveFileAsCNArea();        
      } else {
        this.onSaveFileTo();
      }
    });
    Shortcut.register(document.body, 'f1', (e) => {
      e.preventDefault();
      this.onChangeHelp('getHelp');
    });

  }

  changeWhatSNewState = (newValue)=>{
    const needShow = !newValue.includes('*1');
    this.setState({showWhatsNewDot:needShow});
  }

  checkWhatSNewState = async () => {
    const storeStr = localStorage.getItem('new_update_log_name');
    const res = await store.appStore.getUpdateLogs();
    let needShow = true;
    if(res && res['release'] && res['release'].length !== 0){
      const fileName = res['release'][0];
      if(!storeStr){
        localStorage.setItem('new_update_log_name',fileName+'*0'); //0未读  1已读
      }else{
        const [preFileName,preState] = storeStr.split('*');
        if(preFileName === fileName && preState==='1'){
           needShow = false;
        }
        if(preFileName !== fileName){
          localStorage.setItem('new_update_log_name',fileName+'*0');
        }
      }
      this.setState({showWhatsNewDot:needShow});
    }
  };

  langChange=()=>{
    storageSetItem(localStorage, 'hasChangedLang',true);
    this.isChangeLang();
  }
  isChangeLang=async()=>{
    const config = await baseUrlApis.loadUrlConfig();
    let hasChangedLang =  JSON.parse(storageGetItem(localStorage, 'hasChangedLang'));
    if(!!hasChangedLang){
      this.setState({
        isShowLangTips:false
      })
      return
    }
    let targetLng = '';
    let isAlert = false;
    const { lng } = store.appStore;

    switch(config.userCountry){
      case 'United States':
        if(lng.lang!='en'){
          targetLng = 'en';
          isAlert = true
        }
        break;
      case 'China':
        if(lng.lang!='zh'){
          targetLng = 'zh';
          isAlert = true
        }
        break;
      case 'Japan':
        if(lng.lang!='ja'){
          targetLng = 'ja';
          isAlert = true
        }
        break;
      case 'Germany':
        if(lng.lang!='de'){
          targetLng = 'de';
          isAlert = true
        }
        break;
      case 'Italy':
        if(lng.lang!='it'){
          targetLng = 'it';
          isAlert = true
        }
        break;
      case 'France':
        if(lng.lang!='fr'){
          targetLng = 'fr';
          isAlert = true
        }
        break;
      case 'Spain':
        if(lng.lang!='es'){
          targetLng = 'es';
          isAlert = true
        }
        break;
      case 'Netherlands':
        if(lng.lang!='nl'){
          targetLng = 'nl';
          isAlert = true
        }
        break;
      case 'South Korea':
        if(lng.lang!='ko'){
          targetLng = 'ko';
          isAlert = true
        }
        break;
      default:
        targetLng = 'en';
        isAlert = false
    }
    if(isAlert){
      this.setState({isShowLangTips:true,targetLng},()=>{
        setTimeout(()=>{
          this.setState({
            isShowLangTips:false
          })
        },10000)
      })
    }
  }
  componentDidUpdate(){
    const {headerType} = store.appStore;
    if(headerType === COMMON_HEADER){
      window.pdfui.eventEmitter.on('isProtectedView', val => {
        this.setState({
          isProtectedView:val,
        })
      });
    }
  }
  onChangeLang(lang){
    store.appStore.changeFollowSystemLng(false,lang);//false->自定义语言
    this.setState({
      isShowLangDropdown: false,
      langNewKey: Math.random(),
    });
  }
  onMoreLang() {
    if (window.pdfui && window.pdfui.customs && window.pdfui.customs.showPreferences) {
      window.pdfui.customs.showPreferences('languagesTab');
    }
    this.setState({
      isShowLangDropdown: false
    });
  }
  onChangeHelp(helpKey) {
    //     "get help" opens https://kb.foxitsoftware.com/hc/en-us in a new tab;
    // share feedback is same as feedback feature;
    // Contact us opens online chat box.
    const Events = UIExtension.PDFViewCtrl.Events;
    let { privacyPolicyUrl, termsOfServiceUrl } = this.state;
    switch (helpKey) {
      case 'getHelp':
        let getHelpUrl = isCNDomain()? 'https://help.foxitsoftware.cn/kb.php': 'https://kb.foxitsoftware.com/hc/en-us';
        windowActionFn(window, 'open', [getHelpUrl]);
        break;
      case 'shareFeedback':
        store.appStore.onOpenFeedbackPage();
        break;
      case 'termsOfService':
        let _termsOfServiceUrl = termsOfServiceUrl;
        if (!_termsOfServiceUrl) {
          _termsOfServiceUrl = getTermsOfServiceUrl();
          this.setState({ termsOfServiceUrl: _termsOfServiceUrl })
        }
        this.navToWithBlank(_termsOfServiceUrl, TERM_OF_SERVICE)
        break;
      case 'serviceStatus':
        let serviceStatusUrl = 'https://status.foxit.com';
        windowActionFn(window, 'open', [serviceStatusUrl]);
        break;
      case 'privacyPolicy':
        let _privacyPolicyUrl = privacyPolicyUrl;
        if (!_privacyPolicyUrl) {
          _privacyPolicyUrl = getPrivacyPolicyUrl();
          this.setState({ privacyPolicyUrl:  _privacyPolicyUrl})
        }
        this.navToWithBlank(_privacyPolicyUrl, PRIVACY_POLICY);
        break;
      case 'whatsNew':
          window.pdfui.eventEmitter.emit(Events.showWhatsNew);
          break;
      case 'about':
          // const aboutUrl = 'https://www.foxit.com/pdf-editor/cloud/';
          // windowActionFn(window, 'open', [aboutUrl]);
          store.userStore.goToFoxitOnlineAbout();
          break;
      default:
        break;
    }

    this.setState({ isShowHelpDropdown: false });
  }
  onClickContactUs(){
    store.userStore.doSendGAEventByUser({eventKey:ABOUT_FOXIT_SOFTWARE, label:'upper_right_area'})
    let url = "https://globe-map.foxitservice.com/go.php?title=company-about&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=phantomonline&language=";
    url += store.appStore.lng.full;
    windowActionFn(window, 'open', [url]);
  }
  onSubscribe(){
    if (store.teamsAppStore.inTeamsApp) {
      store.appStore.onShowWarningMessage(() => {}, {
        message: "",
        title: "PhantomPDF.Online.TitleWithOnline",
        cancel: "Close",
        subLink: true,
        noConfirm: true
      });
    } else {
      store.userStore.setSubscribeVisible(true);
    }

    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({eventKey: SUBSCRIBE, label:'review_mode_upper_right_area'});

    }else{
      store.userStore.doSendGAEventByUser({eventKey:SUBSCRIBE, label: 'upper_right_area'});

    }

  }
  onLogoClick() {
    if(isSharedClound())return
    store.userStore.doGoToHomePage();
  }
  onFeedbackNav = () => {
    if(!store.userStore.hasSignIn) {
      store.userStore.signUp()
    } else {
      const feedbackWin = windowActionFn(window, 'open', ['/feedback']);

      function onHandleWindowMessage(event) {
        const action = event.data.action;

        if (action === 'close') {
          feedbackWin.close();

          window.removeEventListener('message', onHandleWindowMessage, false);
        }
      }

      window.addEventListener('message', onHandleWindowMessage, false);
    }
  }
  isHideUserElements =()=>{
    // let pathname = prop(location, 'pathname');
    // switch (pathname) {
    //   case ROUTE_PATH_SURVEY_RESULT: {
    //     return true;
    //   }
    // }
    return false;
  }
  navToWithBlank = (href, butName) => {
    if(!window.__online__){
      store.appStore.doNotifyErrors('offline');
      return;
    }
    if (store.appStore.isCollaborationMode()) {
      store.userStore.doSendGAEvent({eventKey:butName, label: 'review_mode_upper_right_area'});
    }else{
      store.userStore.doSendGAEventByUser({eventKey:butName, label: 'upper_right_area'});
    }
    windowActionFn(window, 'open', [href])
  }
  closeLangTips = () =>{
    storageSetItem(localStorage, 'hasChangedLang',true);
    this.setState({isShowLangTips:false})
  }

  renderLang =(lang)=>{
    switch(lang){
      case 'zh':
        return '简体中文'
      case 'en':
        return 'English'
      case 'ja':
        return '日本語'
      case 'de':
        return 'Deutsch'
      case 'fr':
        return 'Français'
      case 'it':
        return 'Italiano'
      case 'es':
        return 'Español'
      case 'nl':
        return 'Nederlands'
      case 'ko':
        return '한국어'
      default:
        return 'English'
    }

  }
  renderLangMenu = () => {
    const { isShowLangTips, targetLng } = this.state;
    const { lng } = store.appStore;
    const { isBUserGroup } = store.accountStore;

    const langMenu = (
      <Menu
        id="header-language-switch-menu"
      >
        <Menu.Item onClick={this.onChangeLang.bind(this, 'en')}>
          <span>English</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'es')}>
          <span>Español</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'de')}>
          <span>Deutsch</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'fr')}>
          <span>Français</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'it')}>
          <span>Italiano</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'nl')}>
          <span>Nederlands</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'ja')}>
          <span>日本語</span>
        </Menu.Item>
        <Menu.Item onClick={this.onChangeLang.bind(this, 'ko')}>
          <span>한국어</span>
        </Menu.Item>
        <Menu.Item onClick={this.onMoreLang.bind(this)}>
          <span>More</span>
        </Menu.Item>
      </Menu>
    );

    return isBUserGroup ?(
      <Menu.Item className='in-user-profile'>
        <Popover placement='bottomLeft'
                 overlayClassName='lang-pop'
                 content={langMenu}>
          <span><img src={langChange} /> {intl.get('HeaderContainer.Languages')}</span>
        </Popover>
      </Menu.Item>
    ):(
      <React.Fragment>
        <span
          className={'can_click'}
          tabIndex="0"
          role="button"
          aria-label={intl.get('HeaderContainer.switchLaguage')}
          aria-controls="header-language-switch-menu"
          aria-expanded={this.state.isShowLangDropdown}
        >
        <Popover
          // getPopupContainer={triggerNode => triggerNode.parentNode}
          placement="bottomRight"
          destroyPopupOnHide={true}
          arrowPointAtCenter={true}
          visible={isShowLangTips}
          overlayClassName="langTipsPopover"
          content={
            <div className="langTips">
            <img src={langTipsIcon} className='langTipsIcon' alt="" />
            <img src={topClose} className='topClose' alt="" onClick={this.closeLangTips} />
            <div className="content">
              <div className="Title">{intl.getHTML('SignUp.HeaderTitle')}</div>
              <div>
                <p>{intl.get('HeaderContainer.localLang')}{this.renderLang(lng.lang)} </p>
                <p>{intl.get('HeaderContainer.isChangeTo')}{this.renderLang(targetLng)}</p>
              </div>
              <Button onClick={()=>{
                this.onChangeLang(targetLng)
                this.closeLangTips()
              }}>{intl.get('HeaderContainer.changTo')}{this.renderLang(targetLng)}</Button>
            </div>
          </div>
          }>
          <Dropdown overlay={langMenu} onVisibleChange={visible => this.setState({ isShowLangDropdown: visible })}>
            <Avatar
              size="small"
              src={switchLangIcon}
            ></Avatar>
          </Dropdown>
          </Popover>
        </span>
        <span className="line" aria-hidden style={{ margin: '0 10px' }}>|</span>

      </React.Fragment>
    );
  }
  getUpdateDot = (k)=>{
    if(k!=='whatsNew') return null;
    if(!this.state.showWhatsNewDot) return null;
    return <i className="update-red-dot dot-i" />
  }
  renderHelpMenu = () => {
    let helpMenuKeys = ['getHelp', 'shareFeedback', 'whatsNew', 'privacyPolicy', 'termsOfService', 'serviceStatus', 'about'];
    // const { isOnPremiseDeployMode } = store.appStore;
    // if (!isOnPremiseDeployMode && !isCNDomain() && !isJPDomain()) {
    //   helpMenuKeys.push('contactUs');
    // }
    const helpMenu = (
      <Menu id="header-help-menu">
        {
          helpMenuKeys.map( key => {
            return (
              <Menu.Item key={key} onClick={this.onChangeHelp.bind(this, key)}>
                <span>{intl.get(`HeaderContainer.helpMenu.${key}`)} {this.getUpdateDot(key)}</span>
              </Menu.Item>
            )
          })
        }
      </Menu>
    );
    let isFeedbackPage =  this.props.location.pathname === "/feedback";
    return !isFeedbackPage ? (
      <span
        className={`can_click help_menu ${this.state.showWhatsNewDot?'update-red-dot':''}`}
        tabIndex="0"
        role="button"
        aria-label={intl.get('HeaderContainer.helpMenu.getHelp')}
        aria-controls="header-help-menu"
        aria-expanded={this.state.isShowHelpDropdown}
      >
        <Dropdown overlay={helpMenu} overlayClassName={"help_menu_dropdown"} onVisibleChange={visible => this.setState({ isShowHelpDropdown: visible })}>
          <Avatar
            size="small"
            src={helpIcon}
          ></Avatar>
        </Dropdown>
      </span>
    ) : null;
  }
  showShareDlg = async () => {
    let isAccountExpired = store.viewer.pdfui.customs && store.viewer.pdfui.customs.isAccountExpired && store.viewer.pdfui.customs.isAccountExpired(true);
    if (isAccountExpired) {
      return;
    }
    store.userStore.doSendGAEventByUser({eventKey:SHARE_BUTTON, label:'upper_right_area'})

    if(!window.__online__){
      store.appStore.doNotifyErrors('offline');
      return;
    }
    // const { hasSignIn } = store.userStore;
    const hasSignIn = store.loginNewStore.isLogin
    if(!hasSignIn){
      //TODO FOIXT 替换sso登录弹框
      store.loginNewStore.login()
      //store.appStore.doUpdateSignInNotice({id:'Permission.SignIn'});
      return true;
    }


    try {
      const checkAnnotFormPermission = await fileController.checkAnnotFormPermission()

      if (checkAnnotFormPermission === 0) {
        store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Dlg.noPermission")})

        return
      }

      const doc = await pdfui.getCurrentPDFDoc()

      if (doc && doc.isPortfolio()) {
        store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Error.portfolioNotSupport")})

        return
      }

      store.appStore.emitEvent(COLLECT_NPS_SURVEY);
      if(store.viewer.hasOpenFile) {
        store.collaborationStore.changeShareDialogState(true)
      }
    } catch (error) {
      throw error
    }
  }
  showHomeStart = () => {
    const { onShowToSaveBeforeOpen } = store.appStore;

    collaborationService.showCommonModeSidebar()
    function next(){
      onShowToSaveBeforeOpen((isToSave) => {
        if(!isToSave){
          store.viewer.pdfViewer.close();
          store.appStore.backToHomeStart();
        }
      });
    }

      setTimeout(() => {
        next()
      }, 200);
  }

  doSaveToLocalComputer = () => {
    const toSaveFun = (isFromOnlineSign = false)=>{
      console.log("下载？")
      window.pdfui.eventEmitter.emit('document-will-save');
      store.appStore.doShowEditorLoading()
      if (store.appStore.serviceModeOfClientInfo && isWindows) {
        // 下载按钮
        store.userStore.doSendGAEvent({
          eventKey: DOWNLOAD_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING,
          label: 'Top_Bar'
        })
      } else {
        store.userStore.doSendGAEventByUser({eventKey:SAVE_TO_LOCAL, label:'upper_right_area'})
      }
      const { saveToLocalComputer } = store.appStore;
      const { inTeamsApp } = store.teamsAppStore;

      if (saveToLocalComputer) {
        let promise = Promise.resolve();
        if (inTeamsApp) {
          promise = collaborationApi.removeCDocId().catch((error) => {
            throw error
          });
        }
        promise.then(() => {
          saveToLocalComputer({
            error:()=>{store.appStore.doHideEditorLoading()},
            success:()=>{store.appStore.doHideEditorLoading()}
          });
          console.log("下载？2")
          window.pdfui.eventEmitter.emit('document-did-save');
        }).finally( () => {
          if (isFromOnlineSign) {
            setTimeout(() => {
              store.appStore.doUpdateDocModified(false);
            }, 500)
          }
        })
      }
      window.pdfui.eventEmitter.emit('document-did-save');
    };

    const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
    if(hasOnlineSign){
      store.viewer.pdfui.eventEmitter.emit('need-sign-tip', toSaveFun.bind(toSaveFun, true));
      return;
    }

    toSaveFun();
  }
  onShowPrintDialog = async () => {
    if(store.appStore.isCollaborationMode()){
      store.userStore.doSendGAEvent({eventKey: PRINT, label:'review_mode_upper_right_area'});
    }else{
      store.userStore.doSendGAEventByUser({eventKey:HOME_PRINT, label:'upper_right_area'})
    }
    let printButton =  await pdfui.getComponentByName('print-button')
    printButton.controller.handle()
  }

  doOpenLocalFile = () => {
    store.userStore.doSendGAEventByUser({eventKey:OPEN_FILE, label:'upper_right_area'})

    const { onShowToSaveBeforeOpen, openLocalFile } = store.appStore
    const fn = () => {
      openLocalFile();
    };
    onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && fn();
    });
  }
  doCreateNewPDF = () => {
    store.userStore.doSendGAEventByUser({eventKey:CREATE_BLANK_PDF, label:'upper_right_area'})
    store.docStore.setDocDriveName("")

    const { onShowToSaveBeforeOpen } = store.appStore;
    const fn = () => {
      const pdfViewer = pdfui.pdfViewer;
      // pdfViewer.currentPDFDoc.setViewPreference('PageLayout', 'SinglePage');
      // pdfViewer.getViewModeManager().switchTo('single-page-view-mode');
      pdfViewer.createNewDoc(
        store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage ? 
        store.storageAppStore.getBlankFileName() : 
        `${intl.get('HeaderContainer.untitled')}.pdf`).then(() => {
          pdfViewer.currentPDFDoc.setViewPreference('PageLayout', 'SinglePage');
          pdfViewer.getViewModeManager().switchTo('single-page-view-mode');
        });
    };

    onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && fn();
    });
  }
  bulrAnnot = (/*e*/) => {
    store.collaborationStore.unActiveAnnot()
  }
  isShowNotification = () => {
    const { inTeamsApp } = store.teamsAppStore;

    if (this.props.location.pathname !== '/' || inTeamsApp) {
      return false
    } else {
      return true
    }
  }
  onBackToSharePoint = (url) => {
    windowActionFn(window, 'open', [url])
  }
  onSaveCurrentDocBackToGoogleDrive = async (callback) => {
    try {
      await store.driveStore.saveFileBackToGoogleDrive().catch(() => {
        throw 'saved to Google Drive failed.'
      })

      callback && callback()
      store.appStore.doUpdateDocModified(false)
      store.appStore.setGlobalMessage({type: 'success', content: intl.get("SaveFile.success")})
    } catch (error) {
      callback && callback()
      console.error(error);
    }
  }
  onSaveCurrentDocBackToSharepoint = async (callback) => {
    try {
      savingSharePointFile = true
      await store.driveStore.saveFileBackToDrive().catch(() => {
        throw 'saved to share point failed.'
      })

      callback && callback()
      savingSharePointFile = false
      store.appStore.doUpdateDocModified(false)
      store.appStore.setGlobalMessage({type: 'success', content: intl.get("SaveFile.success")})
    } catch (error) {
      savingSharePointFile = false
      callback && callback()
      console.error(error);
    }
  }
  resetSaveFileDebounce = () => {
    this.saveFileDebounce = false
  }
  onSaveFileTo = () => {
    if (this.saveFileDebounce) {
      // store.appStore.setGlobalMessage({type: 'loading', content: intl.get('SavingFile')})

      return
    }

    const { sharePointAutoSavingFlag } = store.driveStore
    const { sharePointInfo: {isFromSharePoint}, googleDriveInfo: {isFromGoogleDrive}} = store.appStore
    const { iManageInfo: { isFromIManage, isSaveBackToIManage } } = store.driveStore
    const {docDriveName} = store.docStore;

    if (isFromSharePoint || isFromGoogleDrive || (isFromIManage && isSaveBackToIManage) || docDriveName) {
      this.saveFileDebounce = true
    }
    const saveFn = () => {
      if (isFromSharePoint) {
        if (!sharePointAutoSavingFlag) {
          !savingSharePointFile && this.onSaveCurrentDocBackToSharepoint(() => {
            this.resetSaveFileDebounce()
          })
        } else {
          store.appStore.setGlobalMessage({type: 'success', content: intl.get("SaveFile.auto")})
        }
      } else if (isFromGoogleDrive) {
        this.onSaveCurrentDocBackToGoogleDrive(() => {
          this.resetSaveFileDebounce()
        })
      } else if (isFromIManage && isSaveBackToIManage) {
        iManageService.updateFile(() => {
          this.resetSaveFileDebounce()
        })
      } else if (docDriveName!=='') {
        if (docDriveName === 'Storage') {
          this.doSaveToLocalComputer();
          this.resetSaveFileDebounce();
          return ;
        }
        message.loading(intl.get('FoxitStorage.AutoSave.Saving'), 0);
        store.driveStore.onSaveFileByMyself(() => {
          message.destroy();
          store.appStore.doHideEditorLoading();
          store.appStore.doUpdateDocModified(false, true);
          this.resetSaveFileDebounce();
        });
      } else {
        this.doSaveToLocalComputer()
      }
    }
    const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
    if(hasOnlineSign){
      store.viewer.pdfui.eventEmitter.emit('need-sign-tip', saveFn.bind(saveFn, true));
      return;
    }

    saveFn();
  }
  onSaveToLocalComputer = () => {
    const saveFn = (isFromOnlineSign) => {
      this.doSaveToLocalComputer(isFromOnlineSign);
    }
    const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
    if(hasOnlineSign){
      store.viewer.pdfui.eventEmitter.emit('need-sign-tip', saveFn.bind(saveFn, true));
      return;
    }
    saveFn(false);
  }
  onSaveFileAsCNArea = () => {
    const Events = UIExtension.PDFViewCtrl.Events;
    const cancelApplyCallback = () => {
        store.appStore.toggleSaveAsDialogCNArea(true);
    }
    if (store.appStore.signChinaStampTotal > 0) {
      window.pdfui.eventEmitter.emit(Events.signChinaNoApply, cancelApplyCallback);
      return;
    }
    const signChinaStampState = window.pdfui.pdfViewer.esignChinaProps?.signChinaStampState;
    if (signChinaStampState) {
        window.pdfui.eventEmitter.emit(Events.signChinaFlowNoApply, cancelApplyCallback);
        return;
    }
    store.appStore.toggleSaveAsDialogCNArea(true)
  }
  openFileInEditorDesktop = () => {
    this.saveLocalFile(true, true);
  }
  saveLocalFile = (auto_open = false, open_phantom = false) => {
    if (!this.checkAppLoginIn()) {
      return;
    }

    let { serviceModeOfClientInfo } = store.appStore;
    if (serviceModeOfClientInfo) {
      if (!serviceModeOfClientInfo.filePath) {
        // 旧版exe 弹窗提示，新功能不可以
        this.showEditorCloudAppModal()
        return;
      }
    let toSaveFun = () => {
        // 增加GA事件
        store.userStore.doSendGAEvent({
          eventKey: `${auto_open ? EDIT_WITH_EDITOR_CLOUD : SAVE_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING}` ,
          label: 'Top_Bar'
        })
        /**
         * exe 改为常驻后 步骤
         * 1、判断exe 有没有 启动（/status）
         * 2、如果未启动弹窗提示并启动，尝试找到 连接的端口好，并且 调用 save 或者 open指令
         * 3、如果启动了，直接调用 save 或者 open指令
         */
        let { baseUrl, port } = serviceModeOfClientInfo;
        clientApi.checkEditorCloudApplicationStatus({baseUrl, port}).then( isStart => {
          if (isStart) {
            this.saveLocalFileHandle(auto_open, open_phantom, port);
          } else {
            let isDoNotShowStartEditorCloudAppModal = false;
            try {
              isDoNotShowStartEditorCloudAppModal = JSON.parse(window.localStorage.getItem('isDoNotShowStartEditorCloudAppModal') || 'false');
            } catch (error) {
            }
            if (isDoNotShowStartEditorCloudAppModal) {
              this.startEditorCloudAppAndSaveToLocal({ auto_open, open_phantom });
            } else {
              // 弹出 启动 EditorCloudApp提示
              this.showStartEditorCloudAppModal({ auto_open, open_phantom });
            }
          }
        })
      }
      const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
      if(hasOnlineSign){
        store.viewer.pdfui.eventEmitter.emit('need-sign-tip', toSaveFun.bind(toSaveFun));
        return;
      }
      toSaveFun();
    }
  }

  saveLocalFileHandle = (auto_open, open_phantom, connectPort) => {
    let { serviceModeOfClientInfo, docModified, loadingMessage } = store.appStore;
    if (!loadingMessage.show) {
      store.appStore.showLoadingWithMsg({ show:true, msg: `HeaderContainer.${auto_open ? 'openingLoading' : 'savingLoading'}` })
    }
    let msg = '';
    let statusCode = 0;
    let failedMsg = auto_open ? 'openFailedMsg' : 'saveFailedMsg';

    let params = {
      pdfViewer: store.viewer.pdfViewer,
      serviceModeOfClientInfo,
      docModified, connectPort, auto_open, open_phantom
    }
    if (docModified) {
      window.pdfui.eventEmitter.emit('document-will-save');
    }
    // 先获取 doc的blob
    fileController.getCurrentDocBuffer().then( res => {
      const fileBlob = new Blob(res[0], { type: 'application/pdf' });
      const file = new File([fileBlob], `${serviceModeOfClientInfo.fileName}`, {type: 'application/pdf'});
      clientApi.saveLocalFile(params, file).then( res => {
        ({msg, statusCode} = res);
        if (typeof msg !== 'string') {
          msg = failedMsg;
        }
      }).finally( () => {
        store.appStore.showLoading(false)
        if (statusCode) {
          if (docModified && statusCode && [200, 206].includes(statusCode)) {
            store.appStore.doUpdateDocModified(false);
            window.pdfui.eventEmitter.emit('document-did-save');
          }
          msg = this.getShowMsgWithStatusCode(statusCode, auto_open)
          if (msg !== 'NoConnectPort' && statusCode !== 207) {
            let showMsg = intl.get(`HeaderContainer.EditorCloudAppErrorMsg.${msg || failedMsg}`)
            message.info(showMsg, 4);
          }
          if (statusCode === 207) {
            // 弹出下载窗口
            this.showDownloadAppModal(open_phantom)
          }
        }
      });
    });
  }

  getShowMsgWithStatusCode = (statusCode, auto_open) => {
    // 200 打开文件成功
    // 204 文件不存在
    // 205 文件被其它程序占用
    // 206 打开文件失败
    // 207 未安装 'Foxit PDF Editor'
    let msg = '';
    switch (statusCode) {
      case 200:
        msg = auto_open ? 'openSuccessMsg' : 'saveSuccessMsg';
        break;
      case 204:
        msg = 'fileNotExist';
        break;
      case 205:
        msg = auto_open ? 'openFileFailedOfFileOccupiedByOtherApplication' : 'saveFileFailedOfFileOccupiedByOtherApplication';
        break;
      case 206:
        if (auto_open) {
          msg = 'openFailedMsg'
        }
        break;
      case 207:
        if (auto_open) {
          msg = 'applicationNotExit';
        }
        break;
      default:
        break;
    }
    return msg;
  }
  checkAppLoginIn = () => {
    if(!window.__online__){
      store.appStore.doNotifyErrors('offline');
      return false;
    }

    if (!store.appStore.checkAppSignIn()) {
      return false;
    }
    return true;
  }

  uploadLocalFile = () => {
    if (!this.checkAppLoginIn()) {
      return;
    }
    // 是否开启CLoud document   ONLINERD-11509
    if (store.appStore.isIncludeFoxitStorage && store.storageAppStore.isDisableStorage) {
      store.viewer.pdfui.alert({ message: intl.get('FoxitStorage.DisableStorage.SharedAlert'), level: 'prompt' });
      return;
    }

    // 企业用户有没有授权 ONLINERD-11508
    const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = store.userStore;
    if (isEnterpriseUser && !hasEditPermissionAndEnterpriseUser) {
      window.pdfui.eventEmitter.emit('need-pay-event');
      // store.appStore.onShowWarningMessage(() => {}, { message: 'account.notActive', title: 'PhantomPDF.Online.TitleWithOnline' }, true);
      return;
    }
    store.appStore.commonForSaveDrives(FOXIT_STORAGE, { isFromExeUpload: true }, 'pdf');
  }

  getFooterContent = () => {
    return (
      <>
        <div className='footer-left'>
          <Checkbox checked={this.state.isShowStartEditorCloudAppModalCheckboxValue} onChange={ e => this.setState({isShowStartEditorCloudAppModalCheckboxValue: e.target.checked}) }>
            {intl.get('DoNotShowAgain')}
          </Checkbox>
        </div>
        <div className='footer-right'>
          <Button onClick={() => this.startEditorCloudAppAndSaveToLocal()} type="primary">
            {intl.get('HeaderContainer.startEditorCloudConfirmBtn')}
          </Button>
          <Button onClick={this.hideStartEditorCloudAppModal}>
            {intl.get('Cancel')}
          </Button>
        </div>
      </>
    )
  }

  hideStartEditorCloudAppModal = () => {
    window.localStorage.setItem('isDoNotShowStartEditorCloudAppModal', this.state.isShowStartEditorCloudAppModalCheckboxValue)
    this.setState({
      isShowStartEditorCloudAppModal: false,
      saveLocalFileConfig: {auto_open: false, open_phantom: false}
    })
  }

  showStartEditorCloudAppModal = (saveLocalFileConfig) => {
    let { auto_open } = saveLocalFileConfig;
    let startEditorCloudAppModalContent = intl.get(`HeaderContainer.${auto_open ? 'startEditorCloudAppTip' : 'startEditorCloudAppTipForSave'}`)
    this.setState({
      isShowStartEditorCloudAppModal: true,
      startEditorCloudAppModalContent,
      saveLocalFileConfig: {...this.state.saveLocalFileConfig, ...saveLocalFileConfig}
    })
  }

  startEditorCloudAppAndSaveToLocal = (saveLocalFileConfig = this.state.saveLocalFileConfig) => {
    this.hideStartEditorCloudAppModal();
    let { serviceModeOfClientInfo } = store.appStore;
    let { auto_open, open_phantom } = saveLocalFileConfig;
    store.appStore.showLoadingWithMsg({ show:true, msg: `HeaderContainer.${auto_open ? 'openingLoading' : 'savingLoading'}` })
    clientApi.startEditorCloudApp(serviceModeOfClientInfo).then( connectPort => {
      if (connectPort) {
        this.saveLocalFileHandle(auto_open, open_phantom, connectPort);
      }
    })
  }
  showEditorCloudAppModal = () => {
    this.setState({
      isShowDownloadEditorCloudAppModal: true
    })
  }
  hideEditorCloudAppModal = () => {
    this.setState({
      isShowDownloadEditorCloudAppModal: false
    })
  }

  onGoForDownloadEditorCloudApp = () => {
    this.hideEditorCloudAppModal();
    store.appStore.downloadEditorCloudApplication();
  }

  showDownloadAppModal = (open_phantom) => {
    let downloadAppModalTitle = intl.get(`HeaderContainer.${open_phantom ? 'titleEditor' : 'titleReader'}`);
    let downloadAppModalContent = intl.get('HeaderContainer.downloadAppContent', { type: downloadAppModalTitle })
    this.setState({
      isShowDownloadAppModal: true,
      downloadAppModalTitle,
      downloadAppModalContent
    })
  }


  hideDownloadAppModal = () => {
    this.setState({
      isShowDownloadAppModal: false
    })
  }

  onGoForDownload = () => {
    this.hideDownloadAppModal();
    let targetUrl = 'https://www.foxit.com/downloads'
    const urlCN = 'https://www.foxitsoftware.cn/downloads'
    const urlJP = 'https://www.foxit.co.jp'

    if (isCNDomain()) {
      targetUrl = urlCN
    }
    if (isJPDomain()) {
      targetUrl = urlJP
    }

    windowActionFn(window, 'open', [targetUrl, '_blank']);
  };

  handleQuickAccess = (name) => {
    const { serviceModeOfClientInfo } = store.appStore;
    switch (name) {
      case 'download':
        const { docDriveName } = store.docStore;
        if (!isCNDomain() && docDriveName && docDriveName !== 'Storage') {
          this.onSaveToLocalComputer();
        } else if (isCNDomain()) {
          this.onSaveFileAsCNArea();
        } else {
          this.onSaveFileTo();
        }
        break;
      case 'save':
        if (serviceModeOfClientInfo && isWindows) {
          this.saveLocalFile();
        } else if (isCNDomain()) {
          this.onSaveFileAsCNArea();
        } else {
          this.onSaveFileTo();
        }
        break;
      case 'open':
        this.doOpenLocalFile();
        break;
      case 'create':
        this.doCreateNewPDF();
        break;
      case 'print':
        this.onShowPrintDialog();
        break;
      case 'saveas':
        if (isCNDomain()) {
          this.onSaveFileAsCNArea();
        } else {
          window.pdfui.eventEmitter.emit('header-open-save-as');
        }
        break;
    }
  };

  getSaveOrDownloadBtn = () => {
    let { serviceModeOfClientInfo } = store.appStore;
    const {isBUserGroup} = store.accountStore;
    let isDownloadBtn = Boolean(serviceModeOfClientInfo && isWindows);
    let iconClass = isDownloadBtn ? 'download-btn' : 'save-btn';
    const { docDriveName } = store.docStore;
    if (docDriveName === 'Storage') {
      return <Tooltip title={intl.get('collaboration.sharedList.SharedTableAction.DownloadBtn')}>
        <i className={`download-btn cursor-pointer icon-btn ${this.state.isProtectedView ? 'disable-normal' : ''}`} onClick={this.onSaveFileTo} />
      </Tooltip>
    }
    if(isCNDomain() && iconClass==='save-btn'){
      iconClass='fx-icon-file_save_as_32_white'
    }
    return  (
      <>
        {
          // 第三方网盘 打开 增加下载到本地的按钮
          !isBUserGroup && !isCNDomain() && docDriveName && docDriveName !== 'Storage' ?
            <Tooltip title={intl.get('HeaderContainer.downloadFile')}>
              <i className={`download-btn cursor-pointer icon-btn ${this.state.isProtectedView ? 'disable-normal' : ''}`} onClick={this.onSaveToLocalComputer} />
            </Tooltip> :
            null
        }
        {
          isCNDomain() ?
          <Tooltip title={intl.get(`HeaderContainer.${isDownloadBtn ? 'downloadFile' : 'SaveAsCNAreaTooltip'}`)}>
            <i className={`${iconClass} cursor-pointer icon-btn ${this.state.isProtectedView ? 'disable-normal' : ''}`} onClick={this.onSaveFileAsCNArea} />
          </Tooltip> :
          <Tooltip title={intl.get(`HeaderContainer.${isDownloadBtn ? 'downloadFile' : 'SaveSameSource'}`)}>
            <i className={`${iconClass} cursor-pointer icon-btn ${this.state.isProtectedView ? 'disable-normal' : ''}`} onClick={this.onSaveFileTo} />
          </Tooltip>
        }
      </>
    )
  }

  render() {
    let isEnablePrint = false;
    const hasDoc = window.pdfui&&window.pdfui.pdfViewer.getPDFDocRender();
    if (store.viewer.pdfViewer && window.UIExtension) {
      const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
      const { User_Permissions } = window.UIExtension.PDFViewCtrl.PDF.constant;
      isEnablePrint = pdfDocRender ?
          !!(pdfDocRender.getUserPermission().getValue() & User_Permissions.print) && !this.state.isProtectedView :
          false;
    }
    //userInfo
    const { userInfo, roleInfo, hasSignIn, isEdu } = store.userStore;
    const {
      appTitleForXX,
      isCustomLogo,
      isCN,
      isOnPremiseDeployMode,
      headerType,
      lng,
      sharePointInfo: { isFromSharePoint, backToSharePointUrl, fromDrive },
      serviceModeOfClientInfo,
      isIncludeFoxitStorage,
    } = store.appStore;
    const { isBUserGroup,isActive, subscriptionState, isDashboardTrial, isPhantomGAEducationOrg } = store.accountStore;
    const { historyParams } = store.historyStore;
    const { fileName, isSecured } = store.docStore.docInfo;
    const { multiTabsTabPaneActiveType } = store.viewer;
    const { name: fName, type: fType } = getFileNameAndType(fileName);
    let fullFileName = `${fileName}${isSecured ? (' ' + intl.get('HeaderContainer.Secured')) : ''}`;
    let fullFileNameWithType ='';
    if(isBUserGroup){
      `${fName}${isSecured ? (' ' + intl.get('HeaderContainer.Secured')) : ''}`;
      fullFileNameWithType = `${fileName}${isSecured ? (' ' + intl.get('HeaderContainer.Secured')) : ''}`;
    }
    const createDropdownMenuItem = (
      <React.Fragment>
        <div className="dropdown-menu-item">
          <span onClick={this.doOpenLocalFile}>{intl.get('HeaderContainer.CreateDropdown.OpenFile')}</span>
        </div>
        <div className="dropdown-menu-item">
          <span onClick={this.doCreateNewPDF}>{intl.get('HeaderContainer.CreateDropdown.CreatePDF')}</span>
        </div>
      </React.Fragment>
    );
    let isCN_Domain = isCNDomain();
    let isJP_Domain = isJPDomain();
    let isPDFOnline_Domain = isPdfOnlineDomain();
    let logoTitle = '';
    let isHideUserElements = this.isHideUserElements(historyParams);
    let isShowSubscribe = !isOnPremiseDeployMode && hasSignIn && !roleInfo && subscriptionState && !isActive && !isDashboardTrial;
    if(isCustomLogo){
      logoTitle = store.appStore.appTitle;
      if(store.appStore.appTitle && store.appStore.appTitle.length >20){
        logoTitle = store.appStore.appTitle.substr(0, 20) + "..."
      }
    }
    // const menu = (
    //   <Menu className='dropdown-downloads'>
    //     <Menu.Item >
    //       <i className="fv__ui-dropdown-button-icon fv__icon-toolbar-download"></i>
    //       <span onClick={()=>{store.appStore.saveToLocalComputer()}} className="fv__ui-dropdown-item-text" >{intl.get('toolbar.buttons.saveToLocal')}</span>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <i className="fv__ui-dropdown-button-icon fv__icon-toolbar-open-one-drive"></i>
    //       <span onClick={()=>{store.appStore.commonForSaveDrives(ONE_DRIVE)}} className="fv__ui-dropdown-item-text" >{intl.get('toolbar.buttons.saveToOneDrive')}</span>
    //     </Menu.Item>
    //     <Menu.Item >
    //       <i className="fv__ui-dropdown-button-icon fv__icon-toolbar-open-box"></i>
    //       <span onClick={()=>{store.appStore.commonForSaveDrives(BOX)}} className="fv__ui-dropdown-item-text" >{intl.get('toolbar.buttons.saveToBox')}</span>
    //     </Menu.Item>
    //     <Menu.Item >
    //       <i className="fv__ui-dropdown-button-icon fv__icon-toolbar-open-drop-box"></i>
    //       <span onClick={()=>{store.appStore.commonForSaveDrives(DROP_BOX)}} className="fv__ui-dropdown-item-text" >{intl.get('toolbar.buttons.saveToDropBox')}</span>
    //     </Menu.Item>
    //     <Menu.Item >
    //       <i className="fv__ui-dropdown-button-icon fv__icon-toolbar-open-google"></i>
    //       <span onClick={()=>{store.appStore.commonForSaveDrives(GOOGLE_DRIVE)}} className="fv__ui-dropdown-item-text" >{intl.get('toolbar.buttons.saveToGoogleDrive')}</span>
    //     </Menu.Item>
    //   </Menu>
    // );
    const inTeams = store.teamsAppStore.inTeamsApp;
    const lmsFile = JSON.parse(window.localStorage.getItem('lms_cur_file_info') || '{}');

    const { autoSaveStatus, curAutoSavedAt } = store.storageAppStore;
    const getFileNameTip = () => {
      return (
        <div>
          <h4>{fullFileNameWithType}</h4>
          <DocOrigin withText={true} />
        </div>
      );
    };
    return (
        <div className={`header_container ${inTeams && isTeamsAndroid ? 'teams_header_container' : ''}`}>
        <Row className={'h-100z p-r'} type="flex" align="middle" justify='space-between' role="banner">
           <Col className={'height_28'} span={isBUserGroup?8:10}>
             {isCanvas()?(<>
                 <span className="canvasTitle">{lmsFile.driveName||null} {'>'} <i className="lmsLogo"></i> {lmsFile.name||null}</span>
             </>):(<>
                {headerType === HOME_HEADER && <div className={'element_l16'} tabIndex="0" role="button" aria-label="Foxit Logo" onClick={this.onLogoClick}>
                  {!isCustomLogo && !appTitleForXX && <img src={store.appStore.appLogo} alt="Foxit Logo" style={{width:`${isCN? "254px": "200px"}`, height:"18px"}}/>}
                  { isCustomLogo &&
                    <span className={'fo_table'}>
                      <span className={'fo_table_cell'}><img src={store.appStore.appLogo} alt="App Logo" style={{height:"18px", width:"24px"}}/></span>
                      <span className={`title ${isCN?'fs-16':'fs-18'}`}>
                        {" " + logoTitle + " "}
                        {intl.get("PhantomPDF.Online.Title")}
                      </span>
                      {!isPDFOnline_Domain && <span className={`title online ${isCN?'fs-16':'fs-18'}`}>{intl.get("PhantomPDF.Online.Online")}</span>}
                    </span>
                  }
                  { appTitleForXX &&
                    <span className={'fo_table'}>
                      <span className={'fo_table_cell'}><img src={store.appStore.appLogo} alt="App Logo" style={{height:"18px", width:"24px"}}/></span>
                      <span className={`title ${isCN?'fs-16':'fs-18'}`}>
                        {" "}
                        {intl.get('PhantomPDF.Online.AppTitleForXX', {name: appTitleForXX})}
                      </span>
                    </span>
                  }
                </div>}
                {headerType === COMMON_HEADER && <div className="left-feature">
                  { !!inTeams ? <i className="home-btn icon-btn disable" /> :
                    <Tooltip getPopupContainer={triggerNode => triggerNode.parentNode} role="button" aria-label={intl.get('HeaderContainer.BackHome')} placement="bottomLeft" title={intl.get('HeaderContainer.BackHome')}>
                      <i className="home-btn icon-btn" onClick={this.showHomeStart}/>
                    </Tooltip>
                  }
                  {isFromSharePoint &&
                    <Tooltip className='back-to-sharepoint-wrapper' getPopupContainer={triggerNode => triggerNode.parentNode} title={intl.get('HeaderContainer.BackToSharePoint', { fromDrive })}>
                      <i className="path-arrow icon-btn"/>
                      <span className="back-to-sharepoint" onClick={this.onBackToSharePoint.bind(this, backToSharePointUrl)}>{intl.get('HeaderContainer.BackToSharePoint', { fromDrive })}</span>
                    </Tooltip>
                  }
                  {isBUserGroup ? (
                      <CustomizeQuickAccessToolbar
                          hasDoc={hasDoc}
                          multiTabsTabPaneActiveType={multiTabsTabPaneActiveType}
                          isEnablePrint={isEnablePrint}
                          isProtectedView={this.state.isProtectedView}
                          clickHandle={this.handleQuickAccess}
                      />
                  ) : (<>
                          <Tooltip className='wrap_document-name' getPopupContainer={triggerNode => triggerNode.parentNode} title={fullFileName}>
                              <i className='onlineLog icon-btn' />
                              <span className='document-name'>{fullFileName}</span>
                          </Tooltip>
                          <DocOrigin />
                          <SavingTip />
                      </>
                  )}
              </div>}
              {headerType === COLLABORATION_HEADER/* &&userInfo */ && <DocumentNameHeader showHomeStart={this.showHomeStart} />}
            </>)}
          </Col>
            {isBUserGroup && (
                <Col span={8} className='middle-col-fileinfo'>
                    {headerType === COMMON_HEADER && <>
                        <Tooltip className='wrap_document-name'
                                 getPopupContainer={triggerNode => triggerNode.parentNode}
                                 title={getFileNameTip}>
                            <span className='document-name'>{fullFileName}</span>
                            <span className='document-type'>.{fType}{
                                (<>
                                    {autoSaveStatus === 'loading' && (<> / <img src={SavingIcon} /> {intl.get('FoxitStorage.AutoSave.Saving')}</>)}
                                    {autoSaveStatus !== 'loading' && curAutoSavedAt && (<> / <img src={SavedIcon} /> {intl.get('FoxitStorage.AutoSave.SavedAt')} {curAutoSavedAt}</>)}
                                </>)
                            }</span>
                        </Tooltip>
                    </>}
                </Col>
            )}
          <Col className={isHideUserElements ? 'd-n' : 'height_26'} span={isBUserGroup?8:14}>
            <div className='element_r40 header-widget-wrapper' onClick={this.bulrAnnot}>
              { isCanvas() && <LMSSubBtn store={store} />}
              {!isCN_Domain&&!isJP_Domain && !isCanvas() && <HeaderEntrance />}
              {
                (headerType === COMMON_HEADER && hasDoc && serviceModeOfClientInfo && isWindows) && (
                  <div className='openInEditorDesktopWrap'>
                    <Button onClick={this.openFileInEditorDesktop} className='openInEditorDesktopBtn'>{intl.get('HeaderContainer.SwitchToEditorDesktop')}</Button>
                  </div>
                )
              }
              {<InstallPWAs lng={lng}/>}
              {headerType === COMMON_HEADER && hasDoc && <React.Fragment>
                <ShareDocButton disabled={this.state.isProtectedView}></ShareDocButton>
                {!isBUserGroup && (<>
                  <span className='icon-btn icon-btn-split' />
                  <UndoButton></UndoButton>
                  <RedoButton></RedoButton>
                  <span className='icon-btn icon-btn-split' />
                  {this.getSaveOrDownloadBtn()}
                  {serviceModeOfClientInfo && isWindows &&
                    <Tooltip title={intl.get('HeaderContainer.saveToLocalTip')}>
                      <i className={`save-origin-btn cursor-pointer icon-btn ${this.state.isProtectedView ? 'disable-normal' : ''}`} onClick={() => this.saveLocalFile()} />
                    </Tooltip>
                  }
                </>)}
                {serviceModeOfClientInfo && isIncludeFoxitStorage &&
                  <Tooltip overlayClassName='wrap_uploadLocalFileToFoxitDocument' title={intl.get('HeaderContainer.uploadLocalFileToFoxitDocumentTip')}>
                    <i className={`upload-local-btn cursor-pointer icon-btn`} onClick={() => this.uploadLocalFile()} />
                  </Tooltip>
                }
                {!isBUserGroup && (<>
                    {multiTabsTabPaneActiveType === MULTI_TABS_TYPES.DOC && <Tooltip title={intl.get('HeaderContainer.Print')}>
                        <i className={`print-btn icon-btn cursor-pointer ${isEnablePrint ? '' : 'disable-normal'}`} onClick={this.onShowPrintDialog} />
                    </Tooltip>}
                    {multiTabsTabPaneActiveType === MULTI_TABS_TYPES.DOC && <Tooltip overlayClassName='header-create-dropdown' title={createDropdownMenuItem}>
                        <i className='create-dropdown icon-btn cursor-pointer' />
                    </Tooltip>}
                    <span className='icon-btn icon-btn-split' />
                    {/* <span style={{margin:"0 10px"}}>|</span>
                <i className="help-btn icon-btn cursor-pointer"/>
                <i className="notify-btn icon-btn cursor-pointer"/>
                <i className="avatar-btn icon-btn cursor-pointer"/>
                <span style={{margin:"0 10px"}}>|</span> */}
                </>)}
              </React.Fragment>}
              {headerType === COLLABORATION_HEADER && !inTeams && <div className='d-n'><UndoButton></UndoButton><RedoButton></RedoButton></div>}
              {headerType === COLLABORATION_HEADER &&/* userInfo&& */<div className='collaboration-header-wrapper'><CollaborationHeader printBtn={this.onShowPrintDialog} /></div>}
              {!isBUserGroup && !isJP_Domain && !isCN_Domain && multiTabsTabPaneActiveType === MULTI_TABS_TYPES.DOC && this.renderLangMenu()}
              {(isCN_Domain || isJP_Domain) && isShowSubscribe &&
                <React.Fragment>
                  <Tooltip title={intl.get('subscription.plan.Subscribe')}>
                    <i className="subscribe-btn icon-btn" onClick={this.onSubscribe} style={{transform: "translateY(1px) translateX(7px)"}}/>
                  </Tooltip>
                </React.Fragment>
              }
              {this.renderHelpMenu()}
              {userInfo && !isOnPremiseDeployMode && (this.isShowNotification() && multiTabsTabPaneActiveType === MULTI_TABS_TYPES.DOC && <NotificationPopover />)}
              <HeaderAvatar key={this.state.langNewKey} userInfo={userInfo} renderLangMenu={this.renderLangMenu} />
            </div>
          </Col>
        </Row>
        {isCN_Domain && isEdu && isPhantomGAEducationOrg && !isDismissEduGuidePopup() ? <EduGuidePopup></EduGuidePopup> : null}
        {this.state.isShowDownloadEditorCloudAppModal &&
          <Modal
            className='downloadEditorCloudAppModal'
            title={intl.get('HeaderContainer.titleEditor')}
            visible={this.state.isShowDownloadEditorCloudAppModal}
            cancelText={intl.get('Cancel')}
            okText={intl.get('HeaderContainer.updateEditorCloudAppBtn')}
            onCancel= {this.hideEditorCloudAppModal}
            onOk={this.onGoForDownloadEditorCloudApp}>
            <div className='downloadEditorCloudAppModalContainer'>
              <div className="info-icon"></div>
              <div className="info-tip">
                  {intl.get('HeaderContainer.downloadEditorCloudAppTip')}
              </div>
            </div>
          </Modal>}
        {this.state.isShowDownloadAppModal &&
          <Modal
            className='downloadAppModal'
            title={this.state.downloadAppModalTitle}
            visible={this.state.isShowDownloadAppModal}
            cancelText={intl.get('Cancel')}
            okText={intl.get('HeaderContainer.downloadAppConfirmBtn')}
            onCancel= {this.hideDownloadAppModal}
            onOk={this.onGoForDownload}>
            <div className='downloadAppModalContainer'>
              <div className="info-icon"></div>
              <div className="info-tip">
                  {this.state.downloadAppModalContent}
              </div>
            </div>
          </Modal>}
        {this.state.isShowStartEditorCloudAppModal && <Modal
            className='startEditorCloudAppAppModal'
            title={intl.get('HeaderContainer.titleEditor')}
            visible={this.state.isShowStartEditorCloudAppModal}
            onCancel= {this.hideStartEditorCloudAppModal}
            footer={this.getFooterContent()}>
            <div className='startEditorCloudAppModalContainer'>
              <div className="info-icon"></div>
              <div className="info-tip">
                {this.state.startEditorCloudAppModalContent}
              </div>
            </div>
          </Modal>}
      </div>
    );
  }
}

export default HeaderContainer;
